// extracted by mini-css-extract-plugin
export var addButton = "_4f-d";
export var bullets = "_4f-e";
export var compact = "_4f-2";
export var container = "_4f-j";
export var extendedWarrantyModal = "_4f-f";
export var learn = "_4f-l";
export var learnMore = "_4f-g";
export var offeringOption = "_4f-3";
export var offeringPrice = "_4f-8";
export var offeringSubtitle = "_4f-7";
export var offeringTitle = "_4f-6";
export var offeringsContainer = "_4f-0";
export var pdpTilesBackground = "_4f-n";
export var plan = "_4f-m";
export var regular = "_4f-1";
export var remove = "_4f-k";
export var seeDetailsIcon = "_4f-i";
export var seeDetailsLink = "_4f-h";
export var selectedOption = "_4f-4";
export var shieldIcon = "_4f-b";
export var shieldIconCompact = "_4f-c";
export var subtitle = "_4f-a";
export var title = "_4f-9";
export var unselectedOption = "_4f-5";